import React, { useContext } from "react";
import "./What_we_offer.css";
import Common_heading from "../../common_components/common_heading/Common_heading";
import { Button } from "react-bootstrap";
import Blue_border_button from "../../common_components/common_btn/blue_border_button/Blue_border_button";
import { Context } from "../../../utils/context";

function What_we_offer() {
  const { language } = useContext(Context);
  const offerData = [
    {
      title: language == 1 ? "Internships " : "Stages ",
      highlight: language == 1 ? "Abroad" : "à l’étranger",
      description:
        language == 1
          ? "Gain real-world experience through career-focused international internships."
          : "Acquérez une expérience concrète grâce à des stages internationaux axés sur la carrière.",
      img: "/assets/images/home/what_we_offer/InternshipsAbroad.jpg",
      button: language == 1 ? "Explore Internships" : "Explorer les stages",
      link: "/internship/4",
    },
    {
      title: language == 1 ? "Study Abroad " : "Étudier à l’étranger ",
      highlight: language == 1 ? "Programs" : "Programmes",
      description:
        language == 1
          ? "Explore MBA, MiM, and medical pathways at globally recognised universities."
          : "Explorez les parcours MBA, MiM et médicaux dans des universités reconnues mondialement.",
      img: "/assets/images/home/what_we_offer/study-ab.jpeg",
      button: language == 1 ? "Find Your Program" : "Trouver votre programme",
      link: "/home",
    },
    {
      title: language == 1 ? "Counselling & " : "Conseil & ",
      highlight: language == 1 ? "Guidance" : "Accompagnement",
      description:
        language == 1
          ? "Get 1-on-1 guidance to choose the right destination and pathway."
          : "Bénéficiez d’un accompagnement individuel pour choisir la bonne destination et le bon parcours.",
      img: "/assets/images/home/what_we_offer/Counselling2.JPG",
      button: language == 1 ? "Book a Session" : "Réserver une séance",
      link: "/contact-us",
    },
  ];

  return (
    <>
      <section className="What_we_offer">
        <div className="container">
          <Common_heading
            headingText={
              language == 1 ? "What We Offer" : "Ce que nous offrons"
            }
          />

          {offerData.map((item, index) => (
            <div className="What_we_offer_holder" key={index}>
              <div className="row">
                {/* IMAGE LEFT - if index is even */}
                {index % 2 === 0 ? (
                  <>
                    <div className="col-md-5">
                      <div className="img_holder">
                        <img
                          className="we_offer_img"
                          src={item.img}
                          alt="offer img"
                        />
                      </div>
                    </div>

                    <div className="col-md-7">
                      <div className="content_holder">
                        <div>
                          <h6>
                            <span>{item.title}</span> {item.highlight}
                          </h6>
                          <p>{item.description}</p>
                          <Blue_border_button
                            link={item.link}
                            button_text={item.button}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {/* IMAGE RIGHT - if index is odd */}
                    <div className="col-md-7 order-md-1 order-2">
                      <div className="content_holder">
                        <div>
                          <h6>
                            <span> {item.title} </span> {item.highlight}
                          </h6>
                          <p>{item.description}</p>

                          <Blue_border_button button_text={item.button} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-5 order-md-2 order-1">
                      <div className="img_holder">
                        <img
                          className="we_offer_img"
                          src={item.img}
                          alt="offer img"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default What_we_offer;
